import styles from "./classTypeMajor.module.less"

function ClassTypeMajor(props) {
  const classList = props.classList
  return (
    <ul className={styles.classList}>
      {classList.map((model) => {
        return (
          <li className={styles.classItem} key={model._id}>
            <h4>{model.name}</h4>
            <ProfessionItem model={model} />
          </li>
        )
      })}
    </ul>
  )
}

export const ProfessionItem = (props) => {
  return (
    <ul className={`${styles.professionList} clearfix`}>
      {props.model.professions.map((profession) => {
        return (
          <li className={styles.professionItem} key={profession._id}>
            <img src={profession.iconUrl} alt="" />
            <div className="profession-content">
              <div>{profession.name}</div>
              <div>{profession.plan}</div>
            </div>
          </li>
        )
      })}
    </ul>
  )
}

export default ClassTypeMajor
